import { api } from "assets/scripts/utilities/api-clients";

export const index = async (options = {}) => {
  const response = await api.get("kam/uoms", options);

  return response;
};

export const post = async (uom) => {
  const response = await api.post("kam/uoms", uom);

  return response;
};

export const put = async (uom) => {
  const response = await api.put("kam/uoms", uom);

  return response;
};
